import { InjectionToken, Type } from '@angular/core';
import { StorageService, IdentityService, InstanceRegistryService, ObservableService } from '@overa/shared';
import { ComponentsService, DynamicComponentsService } from '@overa/dynamic/components';
import { DynamicFormConfigService, DynamicViewService, HookService } from '@overa/dynamic/common';
import { OveraCdkDialogService } from '@overa/components/dialog';
import { UserService } from '@overa/security';
import { ExtendedFilterStateService } from '@overa/components/filter';
import { OveraDataSourceService } from '@overa/components/datasource';
import { BackofficeGlobals } from './globals';

export const dynamic_registry: {
  [key: string]: Type<any> | InjectionToken<any>;
} = {
  Globals: BackofficeGlobals,
  IdentityService: IdentityService,
  StorageService: StorageService,
  ComponentsService: ComponentsService,
  DynamicComponentsService: DynamicComponentsService,
  DynamicFormConfigService: DynamicFormConfigService,
  DynamicViewService: DynamicViewService,
  ObservableService: ObservableService,
  OveraCdkDialogService: OveraCdkDialogService,
  HookService: HookService,
  UserService: UserService,
  FilterStateService: ExtendedFilterStateService,
  InstanceRegistryService: InstanceRegistryService,
  OveraDataSourceService: OveraDataSourceService,
};
